import { NgModule } from '@angular/core';
import { TablaSearchService } from './tabla-search.service';
import { TablaSearchComponent } from './tabla-search.component';
import { CommonModule } from '@angular/common';
import { CustomerArcadeCodeService } from '../../../dms/modulos/general/componentes/gestion-terceros/servicios/customer-arcade-code.service';
import { GridModule } from '@progress/kendo-angular-grid';
import { TranslateModule } from '@ngx-translate/core';

@NgModule({
    imports: [
        CommonModule,
        GridModule,
        TranslateModule
    ],
    declarations: [TablaSearchComponent],
    exports: [TablaSearchComponent],
    providers: [
        CustomerArcadeCodeService,
        TablaSearchService

    ]
})
export class TablaSearchModule { }
